import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Layout from 'components/Layout/Layout';
import Table from 'components/common/Table';
import api from 'services/api';

const Bots = () => {
  const currentLogger = useSelector(state => state.global.currentLogger);

  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const [curPage, setCurPage] = useState(1);
  const [nRequests] = useState(50);
  const [hasMore, setHasMore] = useState(false);

  const formatTimestamp = (timestamp) => {
    if (!timestamp) {
      return;
    }

    return new Date(timestamp).toLocaleString();
  };

  const parseData = (dataToParse) => {
    if (!dataToParse.bots) {
      return;
    }
    const bots = dataToParse.bots;
    const dataParsed = [];
    for (let i = 0; i < bots.length; i++) {
      dataParsed.push([
        i,
        { ipAddress: bots[i].ipAddress, loggerId: currentLogger, requesterId: bots[i].id },
        bots[i].avgTimeTaken,
        bots[i].totalRequests,
        formatTimestamp(bots[i].firstAccess),
        formatTimestamp(bots[i].lastAccess),
      ]);
    }
    return dataParsed;
  };

  /**
   * Fetches for log data.
   */
  const fetchBots = useCallback((curPage = 1) => {
    setIsError(false);
    api.getBots(currentLogger, nRequests, curPage, res => {
      setIsLoading(false);
      if (res.data.status === 200) {
        if (res.data.bots.length < nRequests) {
          setHasMore(false);
        }
        if (curPage !== 1) {
          setData({
            status: res.data.status,
            loggerId: data.loggerId,
            bots: [...data.bots, ...res.data.bots],
          });
        } else {
          setData(res.data);
        }
      } else {
        setIsError(true);
      }
    });
  }, [currentLogger, nRequests, data]);

  const incrementPage = () => {
    fetchBots(curPage + 1);
    setCurPage(curPage + 1);
  };

  /**
   * Calls fetchLogs onload.
   */
  useEffect(() => {
    if (isLoading) {
      fetchBots();
    }
  }, [isLoading, fetchBots]);

  return (
    <Layout title={'Bots'} loading={isLoading} error={isError}>
      {isError}
      <Table
        headerAttributes={[
          'IP Address', 'Avg Time per Request (ms)', 'Total Requests',
          'First Access', 'Last Access'
        ]}
        data={parseData(data)}
        drawIpAddressPosition={1}
        callBackUrl={incrementPage}
        hasMore={hasMore}
      />
    </Layout>
  );
};

export default Bots;
